import { css } from '@emotion/core';
import { variables, media, insetBlock } from '@domain-group/fe-brary';

export const container = css`
  display: flex;
  flex-direction: column;
  color: ${variables.colour.neutral400};
  background: ${variables.colour.neutral800};
  padding: 16px 24px;
  ${media('>=lrg-desktop')} {
    padding: 0;
  }
`;

export const inner = css`
  ${insetBlock};
  ${media('>=desktop')} {
    padding: 30px 0;
  }
`;
